import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  Typography,
  CircularProgress,
} from "@mui/material";
import { db, storage } from "../../../config/firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc, Timestamp } from "firebase/firestore";  // Use addDoc for auto-generated doc ID

const Layout = ({ userId }) => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [screenshot, setScreenshot] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setScreenshot(e.target.files[0]);
    }
  };

  const handleSubmit = async () => {
    if (!name || !phone || !subject || !description) {
      alert("Please fill in all required fields");
      return;
    }

    setLoading(true);
    setSuccessMsg("");

    try {
      let screenshotUrl = null;

      if (screenshot) {
        const storageRef = ref(storage, `help_screenshots/${userId}_${Date.now()}`);
        await uploadBytes(storageRef, screenshot);
        screenshotUrl = await getDownloadURL(storageRef);
      

      // Adding the document to the 'help' collection with an auto-generated ID
      const helpCollectionRef = collection(db, "Help");  // Get reference to 'help' collection
      const newDocRef = await addDoc(helpCollectionRef, {
        name,
        phone,
        subject,
        description,
        screenshotUrl,
        userId, // Add userId as a field in the document
        timestamp: Timestamp.now(),
      });
    }
      setName("");
      setPhone("");
      setSubject("");
      setDescription("");
      setScreenshot(null);
    } catch (error) {
      console.error("Error submitting issue:", error);
      alert("There was an error submitting your issue. Please try again.");
    }

    setLoading(false);
  };

  return (
    <Grid container justifyContent="center" mt={6} px={2} style={{marginTop:"20px"}}>
      <Grid item xs={12} sm={8} md={6}>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <CardContent sx={{ p: 4 }}>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Name :
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Your Name"
                  size="small"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Phone :
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Phone Number"
                  size="small"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Subject :
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Subject"
                  size="small"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Message :
                </Typography>
                <TextField
                  fullWidth
                  placeholder="Describe your issue"
                  multiline
                  rows={4}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  Upload Screenshot (optional) :
                </Typography>
                <input type="file" accept="image/*" onChange={handleFileChange} />
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "#000",
                    color: "#fff",
                    fontWeight: "bold",
                    py: 1.2,
                    borderRadius: "8px",
                    ":hover": {
                      bgcolor: "#222",
  
                    },
                    marginLeft:"160px"
                  }}
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? <CircularProgress size={22} color="inherit" /> : "Contact Us"}
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Layout;
